import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AnalyticsProvider } from "./features/analytics/context/AnalyticsProvider";
import { AuthProvider } from "./features/auth/context/AuthProvider";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const tree = (
  <React.StrictMode>
    <AnalyticsProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </AnalyticsProvider>
  </React.StrictMode>
);

const rootEl = document.getElementById("root")!;

/** `vite preview` serves the HTML shell without SSR — hydrateRoot would mismatch. */
const onlySsrOutletPlaceholder =
  rootEl.childNodes.length === 1 &&
  rootEl.firstChild?.nodeType === Node.COMMENT_NODE &&
  (rootEl.firstChild as Comment).data.includes("ssr-outlet");

if (onlySsrOutletPlaceholder) {
  createRoot(rootEl).render(tree);
} else {
  hydrateRoot(rootEl, tree);
}
